// Bloc « Location » de la fiche véhicule : ce camion est-il loué, et à qui ?
//
// LA LOCATION EN COURS EN PREMIER, puis l'historique : un camion loué trois
// fois a trois contrats, et c'est leur somme qui dit ce qu'il a rapporté.
//
// UNE SEULE LOCATION ACTIVE À LA FOIS. Le serveur répond 409 sinon, et l'écran
// ne propose donc pas d'en ouvrir une seconde : proposer une porte fermée passe
// pour un bug. Un camion SORTI DU PARC ne se loue pas non plus (même refus).
//
// SEUL L'ADMINISTRATEUR OUVRE UNE LOCATION. Le travailleur lit les loyers
// (décision de Yanis, 12/10) mais n'écrit rien : le serveur le refuserait.
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import api, { messageErreur } from "../api";
import { formaterDate, formaterEuros } from "../format";

function libelleEtat(l) {
  if (l.statut === "brouillon") return "En préparation";
  return l.actif ? "En cours" : "Terminée";
}

export default function LocationVehicule({ vehicule, estAdmin }) {
  const navigate = useNavigate();
  const [lignes, setLignes] = useState(null);
  const [erreur, setErreur] = useState("");

  useEffect(() => {
    api
      .get(`/vehicules/${vehicule.id}/locations`)
      .then(({ data }) => setLignes(data))
      .catch((err) => setErreur(messageErreur(err, "Impossible de charger les locations.")));
  }, [vehicule.id]);

  const active = (lignes || []).find((l) => l.actif);

  return (
    <section className="carte">
      <div className="entete-section">
        <h3>Location</h3>
        {estAdmin && lignes && !active && !vehicule.exclu && (
          <button className="btn" onClick={() => navigate(`/vehicules/${vehicule.id}/location/nouvelle`)}>
            Mettre en location
          </button>
        )}
      </div>
      {erreur && <p className="erreur">{erreur}</p>}
      {lignes && lignes.length === 0 && (
        <p className="note-discrete">Ce véhicule n'a jamais été loué.</p>
      )}
      {lignes && lignes.length > 0 && (
        <ul className="liste-simple">
          {lignes.map((l) => (
            <li key={l.id}>
              <strong>{libelleEtat(l)}</strong> · {l.locataire} · du {formaterDate(l.date_debut)} au{" "}
              {formaterDate(l.date_fin)} · {formaterEuros(l.loyer_mensuel)} HT/mois{" "}
              <button className="lien-action" onClick={() => navigate(`/locations/${l.id}`)}>
                {l.statut === "brouillon" && estAdmin ? "Reprendre" : "Ouvrir"}
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
